<template>
  <layout>
    <div class="page-view">
      <banner
        :img="contList.picUrl"
        :title="contList.menuName"
        :subtitle="contList.menuNameEn" />
      <NavBar :navBar="navBar" />
      <div
        class="scheme"
        :key="c.id"
        v-for="(c, i) in contList.menuModule">
        <f-title
          :title="c.title"
          :subtitle="c.titleEn" />
        <div class="scheme-desc">{{ c.content }}</div>
        <ul
          v-if="i === 1"
          class="scheme-palteA">
          <li
            class="item"
            :key="j"
            v-for="(d, j) in c.detailsList">
            <div class="kv">
              <img
                :src="d.imgUrl"
                alt="" />
            </div>
            <div class="cont">
              <div class="cont-title">{{ d.contentTitle }}</div>
              <div class="cont-desc">{{ d.content }}</div>
            </div>
          </li>
        </ul>
        <template v-else-if="i === 2">
          <div
            class="scheme-modules"
            v-for="(d, j) in c.detailsList"
            @click="goPublic(`2-1-${j + 1}`, d.id)"
            :key="d.id">
            <img
              :src="d.imgUrl"
              alt="" />
            <div class="scheme-modules-cont">
              <div class="title">{{ d.title }}</div>
              <div class="more">
                了解更多<span class="iconfont icon-right-1-copy"></span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div
        v-if="$route.fullPath == '/enterpriseHome/enterpriseMobileSecurity'"
        style="text-align: center">
        <div
          class="need-btn"
          @click="goinquiyForm">
          项目需求咨询
        </div>
      </div>
      <div
        class="download"
        v-if="contList.menuModule?.[1]?.externalUrl">
        下载链接：
        <a :href="contList.menuModule[1].externalUrl">{{
          contList.menuModule[1].externalUrl
        }}</a>
      </div>
    </div>
  </layout>
</template>

<script>
import FTitle from '@/components/title.vue';
import Layout from '@/components/moblie/Layout.vue';
import Banner from '@/components/banner.vue';
import NavBar from '@/components/moblie/NavigationBar.vue';
export default {
  components: { Layout, Banner, FTitle, NavBar },
  props: {
    contList: {
      type: Object,
      default: () => {},
    },
    navBar: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  created() {},
  methods: {
    goinquiyForm() {
      this.$router.push({
        name: 'InquiryForm',
        params: {},
      });
    },
    goPublic(row, id) {
      if (row == '2-1-1') {
        this.$router.push({
          name: 'enterpriseHome/enterpriseMobileSecurity/enterprisecublicCloud',
          params: {
            id: id,
          },
        });
      }
      if (row == '2-1-2') {
        this.$router.push({
          name: 'enterpriseHome/enterpriseMobileSecurity/enterprisePrivateCloud',
          params: {
            id: id, // this.getID("私有云服务", this.$store.state.treeList).id
          },
        });
      }

      this.$store.commit('changeTabCheck', {
        idNum: row,
        sumName: '',
      });
      this.$store.state.enterp_somFlg = row.substring(0, 3);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';
/* phone */
@media (max-width: $phone-max-size) {
  $container-width: 343px;
  .page-view {
    .scheme {
      width: $container-width;
      margin: 20px auto;
      &-desc {
        font-weight: 400;
        font-size: 9px;
        color: #666666;
        text-align: center;
        margin-bottom: 27px;
      }
      &-modules {
        position: relative;
        img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          margin-bottom: 25px;
        }
        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.7) 100%
          );
        }
        &-cont {
          position: absolute;
          font-weight: 500;
          font-size: 15px;
          color: #ffffff;
          left: 15px;
          bottom: 17px;
          .more,
          .iconfont {
            font-weight: 400;
            font-size: 10px;
            color: #ffffff;
            opacity: 0.8;
          }
        }
      }
      &-palteA {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: $container-width;
        .item {
          flex-shrink: 0;
          margin-bottom: 20px;
          width: 166px;
          .kv {
            width: 100%;
            height: 120px;
            margin-bottom: 4px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .cont {
            background: #f5f5f6;
            padding: 4px 5px;
            &-title {
              font-weight: 500;
              font-size: 13px;
              color: #151a23;
            }
            &-desc {
              font-weight: 300;
              font-size: 10px;
              color: #151a23;
            }
          }
        }
      }
    }
    .download {
      width: $container-width;
      font-size: 9px;
      margin: 20px auto;
      text-align: center;
    }
    .need-btn {
      font-weight: 500;
      font-size: 12px;
      color: #ffffff;
      background: #04758e;
      display: inline-block;
      padding: 8px 14px;
      margin: 20px 0;
    }
  }
}
/* ipad */
@media (min-width: $ipad-min-size) and (max-width: $ipad-max-size) {
  $container-width: 700px;
  .page-view {
    .scheme {
      width: $container-width;
      margin: 20px auto;
      &-desc {
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        text-align: center;
        margin-bottom: 27px;
      }
      &-modules {
        position: relative;
        img {
          width: 100%;
          height: 300px;
          object-fit: cover;
          margin-bottom: 25px;
        }
        &::before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.7) 100%
          );
        }
        &-cont {
          position: absolute;
          font-weight: 500;
          font-size: 15px;
          color: #ffffff;
          left: 15px;
          bottom: 17px;
          .more,
          .iconfont {
            font-weight: 400;
            font-size: 10px;
            color: #ffffff;
            opacity: 0.8;
          }
        }
      }
      &-palteB {
        &-item {
          height: 300px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
      &-palteA {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: $container-width;
        .item {
          flex-shrink: 0;
          margin-bottom: 20px;
          width: 166px;
          .kv {
            width: 100%;
            height: 120px;
            margin-bottom: 4px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .cont {
            background: #f5f5f6;
            padding: 4px 5px;
            &-title {
              font-weight: 500;
              font-size: 14px;
              color: #151a23;
            }
            &-desc {
              font-weight: 300;
              font-size: 10px;
              color: #151a23;
            }
          }
        }
      }
    }
    .download {
      width: $container-width;
      font-size: 9px;
      margin: 20px auto;
      text-align: center;
    }
    .need-btn {
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      background: #04758e;
      display: inline-block;
      padding: 8px 14px;
      margin: 30px 0;
    }
  }
}
</style>
